import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

@Component({
  selector: 'app-dashboard',
  templateUrl: './sector.component.html',
  styleUrls: ['./dashboard.component.css']
})


export class SectorComponent implements OnInit {

  public alertOption: SweetAlertOptions = {};  
  @ViewChild('sectorSelSwal') private sectorSelSwal: SwalComponent;

  title = 'Pareekshn';
  selectedValue: any = 'topic';
  userinfo: any;
  studentid: number = 0;
  isErrorUsername: boolean;
  errorMsg: any;
  loading: boolean;
  examdata: any;
  futureexams: any;
  pastexams: any;
  livexam: any;
  isValid = true;
  pg: number = 0;
  usertoken: string;
  todayDate: Date = new Date();
  liveexam: number = 0;
  pastexam: number = 0;
  futureexam: number = 0;
  examicon: string;
  sectorlist = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

  ngOnInit() {

    //let auth_token = 'MTQ1YjE4ZDI2Mjc1MzQ4MGM2Njc5MTNlNDdmMWY2MGVfUGFyQDIzQE1F';
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.usertoken = this.userinfo['usertoken'];
    this.choosesectors();
  }

startExam(examid)
{
  sessionStorage.setItem('pkshn_select_exam_ps', examid);
  this.router.navigateByUrl('/login');  
}

sectorArrLength;
choosesectors()
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.getSectors(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          if (data.code == 1000) {
            this.sectorlist = data.sector;
            this.sectorArrLength = this.sectorlist.length;
            this.loading = false;
            this.spinner.hide();
          }
          else {
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }          
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
loodQP(sectorid, status)
{
  if(status == 1)
  {
    this.router.navigateByUrl('/qpacks/'+sectorid);
  }
  else{
    this.sectorSelSwal.show(); 
  }
}
select: number = 0;
sectorSelected(e, sectorid)
{ 
  //this.loading = true;
  this.spinner.show();
  var currentOptBtn = document.getElementById('op-' + sectorid) as HTMLInputElement;
  if(currentOptBtn.checked == true)
  {
    this.select = 1;
  }
  else{
    this.select = 0;          
  }
    this.authenticationService.setSectors(this.globals.root_url, this.studentid, this.usertoken, sectorid, this.select)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          if (data.code == 1000) {
            this.choosesectors();
          }
          else {
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }
          
        },
        error => {
          this.errorMsg = 'Some problem. Please try again... !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
 goDashboard()
 {
  this.router.navigateByUrl('/dashboard'); 
 } 
}





